/**
 * 在頁面切換時將路由資訊寫進 Pinia Store，讓其他組件可以使用這些資訊來判斷使用者的行為路徑
 */

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { $pinia } = useNuxtApp();
  const mainStore = await useMainStore($pinia);
  mainStore.previousPathName = from.name as string;
});
